import Splide from "@splidejs/splide";
import "@splidejs/splide/css";

const CounterCarousel = () => {
  const counters = document.querySelectorAll(".wp-block-group.counter-slider");

  if (counters.length === 0) return;

  const options = {
    perPage: 3,
    perMove: 1,
    pagination: false,
    arrows: false,
    spaceBetween: 20,
    drag: false,
    autoplay: false,
    padding: 0,
    trimSpace: false,
    start: 0,
    width: "100%",
    padding: {
      right: "3rem",
    },
    breakpoints: {
      781: {
        type: "loop",
        focus: "center",
        perPage: 2,
        autoplay: true,
        pauseOnFocus: true,
        drag: true,
        gap: "0rem",
      },
    },
  };

  const setClasses = (counter) => {
    counter.parentNode.classList.add("splide");
    counter.classList.add("splide__track");
    counter.querySelector(".wp-block-columns")?.classList.add("splide__list");
    counter.querySelectorAll(".wp-block-column").forEach((column) => column.classList.add("splide__slide"));
  };

  const initSplide = (counter, idx) => {
    if (counter.querySelectorAll(".wp-block-column").length === 0) return;
    counter.parentNode.id = `splide-counter-${idx}`;
    setClasses(counter);
    new Splide(`#splide-counter-${idx}`, options).mount();
  };
  counters.forEach(initSplide);
};

export default CounterCarousel;
